let apiBase;
let apiFintech;
let requestOptions;
let syncOrderDinnerSocketUrl;
let sockJsUncheckUrl;
let apiAdsgroup;
let apiStatistics;
let loyaltyHost;
let adHost;
function getHostNameWithProtocol(hostname) {
  if (typeof location === 'object') {
    return `${location.protocol}//${hostname}`;
  }

  return `http://${hostname}`;
}

switch (process.env.NODE_ENV) {
  case 'production':
    apiBase = getHostNameWithProtocol(process.env.PROD_HOST);
    apiStatistics = getHostNameWithProtocol(process.env.STATISTICS_HOST);
    apiFintech = process.env.FINTECH_HOST;
    syncOrderDinnerSocketUrl = process.env.WS_HOST;
    sockJsUncheckUrl = process.env.SJ_HOST;
    apiAdsgroup = process.env.ADSGROUP_HOST;
    loyaltyHost = getHostNameWithProtocol(process.env.LOYALTY_HOST);
    adHost = getHostNameWithProtocol(process.env.AD_HOST);

    requestOptions = {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        Accept: 'application/json',
      },
    };
    break;
  default:
    apiBase = `${getHostNameWithProtocol(process.env.DEV_HOST)}:3001`; // 本地环境
    apiStatistics = `${getHostNameWithProtocol(process.env.DEV_HOST)}:3001`; // 本地环境
    adHost = 'https://citestad.shishike.com/ad-srs';
    // 仅在本地前后端联调使用
    if (process.env.API_HOST) {
      apiBase = process.env.API_HOST;
    }

    apiFintech = 'https://test-fintech.shishike.com/eip/'; // 对接Fintech的环境
    syncOrderDinnerSocketUrl = 'testwxws.shishike.com';
    sockJsUncheckUrl = 'citestpws.shishike.com';
    apiAdsgroup = 'http://172.16.30.3:8087';
    loyaltyHost = 'loyalty.keruyun.com';

    requestOptions = {
      method: 'GET',
      mod: 'cors',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        Accept: 'application/json',
      },
    };
}

module.exports = {
  // API
  queryTaxRateByGoodsApi: `${apiBase}/taxRate/queryTaxRateByGoods.json`, // 通过菜品查询消费税税率
  getIndustryApi: `${apiBase}/brand/industry.json`, // 获取业态信息
  deliveryOrderAPI: `${apiBase}/order/deliveryOrderList.json`,
  takeawayDishListAPI: `${apiBase}/takeaway/dishAll.json`,
  getGoodsDetailAPI: `${apiBase}/orderall/goodsDetail.json`,
  takeawayShopInfoAPI: `${apiBase}/takeaway/orderPageInfo.json`,
  orderallDishListAPI: `${apiBase}/orderall/dishAll.json`,
  orderAllYDListAPI: `${apiBase}/prepare/dishAll.json`,
  orderallShopInfoAPI: `${apiBase}/orderall/orderPageInfo.json`,
  orderDineInAPi: `${apiBase}/orderall/dishBox.json`,
  orderDineInTableListAPI: `${apiBase}/orderall/tableInfoList.json`,
  orderTakeAwayAPi: `${apiBase}/takeaway/dishBox.json`,
  orderCouponsAPI: `${apiBase}/coupon/getCanUseCoupons.json`,
  orderNewCouponsAPI: `${apiBase}/coupon/getNewCanUseCoupons.json`,
  orderWeixinGiftCardsAPI: `${apiBase}/coupon/getWeixinGiftCards.json`,
  orderDiscountInfoAPI: `${apiBase}/shop/discountInfo.json`,
  orderDinnerStatementAPI: `${apiBase}/orderall/settlement4Dinner.json`,
  orderDinnerStatementZeroAPI: `${apiBase}/pay/pay4Zero.json`,
  submitTSOrderAPI: `${apiBase}/orderall/subOrder.json`,
  submitWMOrderAPI: `${apiBase}/takeaway/subOrder.json`,
  userAddressAPI: `${apiBase}/user/addressList.json`,
  submitDinnerOrderAPI: `${apiBase}/orderall/tradeBilling.json`,
  orderedDishBenefitAPI: `${apiBase}/marketplan/dishPrivilegeList.json`, // 单商品优惠
  multiDishBenefitAPI: `${apiBase}/marketplan/multiDishPrivilegeInfo.json`, // 多商品优惠
  orderAddOnAPI: `${apiBase}/marketplan/addOnOderPlanInfo.json`, // 凑单商品列表
  orderCouponsCountAPI: `${apiBase}/coupon/getCanUseCouponCnt.json`, // 个人中心优惠券总计数量
  orderPurchaseBenefitAPI: `${apiBase}/marketplan/markUpPlanInfo.json`, // 加价-满额换购接口
  discountCardListApi: `${apiBase}/rightsCard/queryCanUseCardList.json`, // 折扣卡列表
  getRightsCardsListApi: `${apiBase}/rightsCard/getRightsCardsList.json`, // 商城折扣卡列表
  getLimitedPrivilegeApi: `${apiBase}/marketplan/limitedPrivilege.json`, // 茶百道限免优惠
  getOrderMemo: `${apiBase}/order/orderMemoConfig.json`, // 订单备注列表
  orderAgain: `${apiBase}/takeaway/orderagain.json`, // 再来一单

  individualAPI: `${apiBase}/user/individual.json`, // 获取用户基本信息(我的页面)
  individualviewAPI: `${apiBase}/user/individualView.json`, // 获取用户基本信息(设置页面)
  freePaymentCodeAPI: `${apiBase}/member/noPwdPayCode.json`, // 免密支付二维码
  logoutAPI: `${apiBase}/user/logout.json`, // 注销用户页面
  individualupdateAPI: `${apiBase}/user/individualUpdate.json`, // 设置页面 更新信息
  getUserAddressListAPI: `${apiBase}/user/getAddressList.json`,
  getAllAddressListAPI: `${apiBase}/user/addressList.json`,
  customerAddressAPI: `${apiBase}/user/address.json`,
  saveAddressAPI: `${apiBase}/user/saveAddress.json`,
  deleteAddressAPI: `${apiBase}/user/delAddress.json`,
  getOrderAddressInfoAPI: `${apiBase}/user/getAddressInfo.json`,
  submitTSOrderCartAPI: `${apiBase}/orderall/subOrderDinner.json`,
  placeCheckOrderAPI: `${apiBase}/place/placeCheckOrder.json`,
  mustOrderDishListAPI: `${apiBase}/orderall/queryMustDishList.json`,
  getIParkSecretAPI: `${apiBase}/orderall/thirdPlatform/getIParkSecret.json`, // 获取美食岛秘钥

  userLoginAPI: `${apiBase}/user/login.json`,
  userLoginWXURL: `${apiBase}/user/login4WX`,
  userLoginAlipayURL: `${apiBase}/user/login4Alipay`,
  aliapiAuthURL: `${apiBase}/aliapi/authByAlipay`,
  getMerchantsBankInfoAPI: `${apiBase}/blank/getInfo.json`,
  getUserLoginSupportAPI: `${apiBase}/user/supportTypes.json`,
  getServiceStatusHaveTableAPI: `${apiBase}/orderall/serviceStatusHaveTable.json`, // 获取基本信息(带桌台)
  getServiceStatusNoTableAPI: `${apiBase}/orderall/serviceStatusNoTable.json`, // 获取基本信息(不带桌台)
  getIsShowButtonAPI: `${apiBase}/orderall/isShowButton.json`, // 按钮是否显示
  getTableInfoAPI: `${apiBase}/orderall/tableInfo.json`, // 获取tableInfo
  getOtherTableIdAPI: `${apiBase}/orderall/getTableId.json`, // 获取用户是否在其他桌台下单
  getOrderTableTypeAPI: `${apiBase}/orderall/orderTableType.json`, // 获取tableInfo
  callServiceAPI: `${apiBase}/orderall/callService.json`, // 获取tableId
  memberIndexAPI: `${apiBase}/member/index.json`, // 获取会员基本信息
  grownLevelxAPI: `${apiBase}/member/customerLevel.json`, // 会员页面
  getCouponListAPI: `${apiBase}/coupon/getCouponList.json`, // 优惠券列表
  getBrandCouponNum: `${apiBase}/coupon/brandCouponNum.json`, // 优惠券使用张数
  // 跳转URL
  dishMenu4DinnerURL: `${apiBase}/orderall/selectDish`, // 堂食点餐页，后端会进行重定向，决定正餐、快餐跳转
  dishMenu4takeoutURL: `${apiBase}/takeaway/getWMPageTpl`, // 外卖和零售点餐页中转页面
  dishMenu4RealtakeoutURL: `${apiBase}/takeaway/selectDish`, // 真实的外卖点餐页

  bookingURL: `${apiBase}/booking/book`, // YD
  queueInfoURL: `${apiBase}/queue/info`, // PD
  paySuccessURL: `${apiBase}/shop/paySuccess`, // 支付成功页面
  // 点金计划
  goldenPlan: `${apiBase}/shop/goldenplan`, // 点金计划页
  blankJump: `${apiBase}/shop/blankjump`, // 空白跳转页
  goldenplanhint: `${apiBase}/shop/goldenplanhint`, // 错误提示页
  // 门店列表页
  shopTSListURL: `${apiBase}/shop/list`,
  shopWMListURL: `${apiBase}/shop/wmList`,
  cooksListAPI: `${apiBase}/cook/cookList.json`,

  editUserAddressURL: `${apiBase}/user/address`,
  editBakeAddressURL: `${apiBase}/retail/address-edit`,

  // evaluationURL: 'https://gldpartner.keruyun.com/gateway-fronend/mobile.html#/commentH5', // 评价页面
  evaluationURL: 'https://partner.keruyun.com/gateway-fronend/mobile.html#/commentH5', // 评价页面

  brandIndexURL: `${apiBase}/brand/index`, // 品牌首页
  shopDetailURL: `${apiBase}/shop/detail`, // 门店首页
  bakeDishMenuURL: `${apiBase}/retail/`, // 烘焙点餐页
  mineIndexURL: `${apiBase}/integration/personal-center`, // 个人中心页面
  mineCardMallURL: `${apiBase}/integration/card-mall`, // 个人中心 - 折扣卡商城页面
  mineSettingURL: `${apiBase}/user/individualView`, // 设置页面
  bindMobileURL: `${apiBase}/user/bindMobile`, // 绑定手机页面
  bindWXURL: `${apiBase}/user/bindOpenid`, // 绑定微信页面
  bindAlipayURL: `${apiBase}/user/bindAlipay`, // 绑定支付宝页面
  registerMemberURL: `${apiBase}/member/register`, // 注册会员
  logAddressURL: `${apiBase}/user/notLogin`, // 登录页面
  integralURL: `${apiBase}/member/integral`, // 我的积分
  valueCardURL: `${apiBase}/member/valueCard`, // 我的余额
  memberIndexURL: `${apiBase}/member/index`, // 会员页面
  grownLevelxURL: `${apiBase}/member/grownLevel`, // 会员页面
  growthValueURL: `${apiBase}/member/growthValue`, // 成长明细页面
  rechargeURL: `${apiBase}/shop/recharge`, // 充值页面
  orderallListURL: `${apiBase}/order/orderallList`, // 订单列表
  getCouponListURL: `${apiBase}/coupon/getCouponList`, // 优惠券
  addressListURL: `${apiBase}/user/addressList`, // 地址管理
  modifyPwdURL: `${apiBase}/member/modifyPwd`, // 修改密码
  tradeDetailUncheckURL: `${apiBase}/order/tradeDetailUncheck`, // 堂食正餐订单详情页 结算前
  dishCart4DinnerURL: `${apiBase}/orderall/dishCart4Dinner`, // 购物车详情页
  dishCart4DinnerPayFirst: `${apiBase}/orderall/dishCart4DinnerPayFirst`, // 购物车详情页
  settlement4DinnerURL: `${apiBase}/orderall/settlement4Dinner`, // 正餐结算页面
  takeout4DinnerURL: `${apiBase}/takeaway/dishBox`, // 外卖结算页面
  orderall4DinnerURL: `${apiBase}/orderall/dishBox`, // 快餐结算页面
  takeOutDetailURL: `${apiBase}/order/takeOutDetail`, // 外卖订单详情页面
  orderallDetailURL: `${apiBase}/order/orderallDetail`, // 堂食订单详情页面
  takeOutRefundDetailURL: `${apiBase}/order/takeOutRefundDetail`, // 部分退详情页面
  dishMenu4DinnerChoosePeopleURL: `${apiBase}/orderall/dishMenu4DinnerChoosePeople`, // 堂食正餐点餐选择人数
  changeMobileSucURL: `${apiBase}/user/changeMobileSuc`, // 修改绑定手机成功页
  changeMobileURL: `${apiBase}/user/changeMobileInfo`, // 修改绑定手机页
  valueCardDetailURL: `${apiBase}/member/valueCardDetail`,
  cooksListURL: `${apiBase}/cook/cookList`,
  cookPersonalIndexURL: `${apiBase}/cook/cookInfo`,
  validBindMobileURL: `${apiBase}/user/validBindMobile`, // 绑定手机验证码校验：是否会员/是否和其他微信绑定
  bookingDetailURL: `${apiBase}/booking/bookingDetail`, // 预定详情
  bookCheckOrderURL: `${apiBase}/prepare/dishBoxBooking`, // 预定下单页面
  isQueueURL: `${apiBase}/queue/queueCheck.json`, // 是否已排队
  queueDetailURL: `${apiBase}/queue/success`, // 排队详情
  queueCheckOrderURL: `${apiBase}/prepare/dishBoxQueue`, // 排队下单页面
  goodsDetailURL: `${apiBase}/orderall/goodsDetail`, // 商品详情页面
  exceptionLinkURL: `${apiBase}/orderall/tableError`, // 异常页面(链接无效)
  commodityfeLinkURL: shopId => `${apiBase}/commodityfe/?shopId=${shopId}&/#/`, // 新零售页面
  payDetailURL: `${apiBase}/shop/payDetail`,
  takeoutTrackURL: `${apiBase}/order/deliveryOrderList`,
  prepaidCodeUrl: `${apiBase}/integration/prepaid-code`,

  addPrepaidCodesAPI: `${apiBase}/prepay/addPrepayCodes.json`,
  couponReceivedInfoAPI: `${apiBase}/coupon/query/presentCouponNote.json`,
  queryMarketShareStatusAPI: `${apiBase}/coupon/queryMarketShareStatus.json`,

  getQryCommercialConfig: `${apiBase}/commodity/qryCommercialConfig`, // 零售配置导航接口
  getQueuePredictWaitTimeAPI: `${apiBase}/queue/predictWaitTime.json`, // 排队等待时间
  getDefaultSendArea: `${apiBase}/user/getDefaultSendArea.json`,
  queryDeliveryTime: `${apiBase}/takeaway/queryDeliveryTime.json`, // 点单页显示配送时间
  getOrderInLineAPI: `${apiBase}/queue/info.json`,
  submitOrderInLineAPI: `${apiBase}/queue/add.json`,
  checkQueueAPI: `${apiBase}/queue/queueCheck.json`,
  placeOrderAPI: `${apiBase}/booking/book.json`,
  payPlaceOrderAPI: `${apiBase}/booking/getBookingDeposit.json`,
  getCheckTableAvaliable: `${apiBase}/booking/getTableByAreaAndNum.json`,
  getPlaceOrderTablesAPI: `${apiBase}/booking/getTables.json`,
  submitPlaceOrderAPI: `${apiBase}/booking/addBooking.json`,
  confirmBookingAPI: `${apiBase}/booking/confirmBooking.json`, // 确认预定
  cancelBookingAPI: `${apiBase}/booking/cancelBooking.json`, // 取消预定

  checkMobileBindedAPI: `${apiBase}/user/checkMobileBinded.json`, // 发送验证码之前 验证手机号是否已经绑定
  checkMobileOccupyAPI: `${apiBase}/user/checkMobileOccupy.json`, // 发送验证码之前 验证手机号是否已经绑定
  sendCodeAPI: `${apiBase}/user/sendCode.json`, // 发送验证码
  bindPhoneAPI: `${apiBase}/user/bindMobile.json`, // 绑定手机
  changeMobileAPI: `${apiBase}/user/changeMobile.json`, // 修改已经绑定的手机号
  wxOauthAPI: `${apiBase}/openapi/weixinOauthUrl`, // 获取微信 openid
  bindWXAPI: `${apiBase}/user/bindOpenid.json`, // 绑定微信
  bindAlipayAPI: `${apiBase}/user/bindAlipay.json`, // 绑定支付宝
  getWXInfoAPI: `${apiBase}/user/weixinUserInfo.json`, // 获取微信信息
  getAlipayInfoAPI: `${apiBase}/user/alipayUserInfo.json`, // 获取支付宝信息

  getCurrentCountryList: `${apiBase}/brand/getCurrencyList.json`,

  registerInfoAPI: `${apiBase}/member/register.json`, // 获取用户信息
  registerAPI: `${apiBase}/member/addMember.json`, // 申请会员
  checkCodeAvaliableAPI: `${apiBase}/user/validMobile.json`,
  tradeDetailUncheckAPI: `${apiBase}/order/tradeDetailUncheck.json`, // 订单详情（结算前）
  tradeDetailUncheckPayFirstAPI: `${apiBase}/order/tradeDetailDinnerPayFirst.json`, // 订单详情（结算前，正餐先付）
  getWXAuthInfoAPI: `${apiBase}/openapi/jsApiTicket.json`,
  getWXCardAPI: `${apiBase}/weixinapi/wxCardTicket.json`, // 领取微信卡券
  getTableIdFromQRCodeAPI: `${apiBase}/orderall/tableExt.json`,
  getMainOrderAPI: `${apiBase}/orderall/getMainOrder.json`,
  validBindMobileAPI: `${apiBase}/user/validBindMobile.json`, // 绑定手机验证码校验：是否会员/是否和其他微信绑定
  validBindMobileActiveAPI: `${apiBase}/user/validBindMobileActive.json`, // 绑定手机验证码校验(会员卡激活)：是否会员/是否和其他微信绑定
  verifyMemberCodeAPI: `${apiBase}/member/verifyMemberCode.json`, // 验证核销会员码
  validateMemberCodeAPI: `${apiBase}/member/validateMemberCode.json`, // 验证会员码
  aliPayEnvelopeAPI: `${apiBase}/aliapi/alipayMarketing.json`, // 手机领取支付宝红包
  getInvoiceStatus: `${apiBase}/order/invoiceStatus.json`, // 开票状态接口
  getInvoiceUrl: `${apiBase}/order/invoiceUrl.json`, // 发票路径

  getBalanceInfoAPI: `${apiBase}/member/valueCard.json`, // 会员卡余额信息
  getBalanceShopDetailListAPI: `${apiBase}/member/valueCardList.json`, // 会员卡余额信息详情
  getCommercialGroupAPI: `${apiBase}/user/getCommercialGroup.json`,
  getIntegralDetailAPI: `${apiBase}/member/integralDetail.json`, //
  getGrownDetailAPI: `${apiBase}/member/grownDetail.json`, //
  getRechargeInfoAPI: `${apiBase}/shop/recharge.json`, // 会员卡充值信息
  addRechargeAPI: `${apiBase}/member/addRecharge.json`, // 会员卡充值
  storePayAPI: `${apiBase}/member/storePay.json`, // 储值并支付
  rechargeShopListAPI: `${apiBase}/shop/allShopList.json`, // 储值选择门店
  indexAPI: `${apiBase}/brand/index.json`,
  brandShopList: `${apiBase}/shop/brandShopList.json`, // 品牌下的门店列表
  modifyPwd: `${apiBase}/member/modifyPwd.json`, // 修改密码
  resetPassword: `${apiBase}/member/resetPassword.json`, // 重置密码
  getResetPasswordUserInfoAPI: `${apiBase}/member/resetPwd.json`, // 取密码重置用户信息

  cancelQueueAPI: `${apiBase}/queue/cancel.json`, // 取消排队
  supportBusinessTypesAPI: `${apiBase}/order/supportBusinessTypes.json`, // 订单列表
  orderListAPI: `${apiBase}/order/orderallList.json`, // 订单列表
  orderListMoreAPI: `${apiBase}/order/historyOrderallList.json`, // 十五天前的订单列表
  takeOutListAPI: `${apiBase}/order/takeOutList.json`, // 外卖列表
  takeOutRefundDetailAPI: `${apiBase}/order/takeOutRefundDetail.json`, // 部分退详情
  takeOutListMoreAPI: `${apiBase}/order/historyTakeOutList.json`, // 十五天前的外卖列表
  bookListAPI: `${apiBase}/order/bookingList.json`, // 预订列表
  queueListAPI: `${apiBase}/queue/queueList.json`, // 排队列表
  bakeListAPI: `${apiBase}/bakingOrder/bakingOrderAllList.json`, // 烘焙订单列表
  getDinnerDetailAPI: `${apiBase}/order/orderallDetail.json`, // 堂食结算后订单详情
  getHistoryDinnerDetailAPI: `${apiBase}/order/historyOrderallDetail.json`, // 历史订单堂食结算后订单详情
  getDishMarketInfosAPI: `${apiBase}/orderall/dishMarketInfos.json`,
  saveMarkRecordAPI: `${apiBase}/order/saveMarkRecord.json`, // 评分
  getRemindOrderAPI: `${apiBase}/takeaway/remindOrder.json`, // 催单次数

  getBookDetailAPI: `${apiBase}/booking/bookingDetail.json`, // 预订详情
  getQueueDetailAPI: `${apiBase}/queue/success.json`, // 排队详情
  bookingMyPreOrderAPI: `${apiBase}/prepare/bookingMyPreOrder.json`, // 预定我的菜单
  queueMyPreOrderAPI: `${apiBase}/prepare/myPreOrder.json`, // 排队我的菜单
  bookingSubOrderAPI: `${apiBase}/prepare/bookingSubOrder.json`,
  queueSubOrderAPI: `${apiBase}/prepare/subOrder.json`,

  getOrderPotTime: `${apiBase}/order/getOrderPotTime.json`, // 外卖 - 预约收锅时间获取
  setOrderPotTime: `${apiBase}/order/orderPot.json`, // 外卖 - 预约收锅时间设置
  getPotTimeList: `${apiBase}/takeaway/genePotTimeList.json`,
  getTakeoutDetailAPI: `${apiBase}/order/takeOutDetail.json`, // 外卖结算后订单详情
  getHistoryTakeoutDetailAPI: `${apiBase}/order/historyTakeOutDetail.json`, // 历史订单结算后订单详情
  getCurrIntegralRuleAPI: `${apiBase}/member/currIntegralRule.json`, // 获取当前积分信息
  getCurrGrownRuleAPI: `${apiBase}/member/currGrownRule.json`, // 获取当前成长值信息

  getPosLoginInfoAPI: `${apiBase}/user/loginPosScanCode.json`, // pos扫码信息
  loginWxByPosAPI: `${apiBase}/user/loginWxByPos.json`, // pos扫码登录
  getPayDetailAPI: `${apiBase}/shop/payDetail.json`,
  getEbuAPI: `${apiBase}/pay/elmPay.json`, // ebu 支付
  baiduPayAPI: `${apiBase}/pay/baiduPay.json`,
  weixinPayAPI: `${apiBase}/pay/weixinPay.json`,
  ccbPayAPI: `${apiBase}/pay/ccbPay.json`,
  balancePayAPI: `${apiBase}/pay/valueCardPay.json`,
  balancePayOmitPasswordAPI: `${apiBase}/pay/valueCardPayOmitPassword.json`,
  balancePayBrandAPI: `${apiBase}/pay/qrcodeValueCardPay.json`,
  balancePayBrandOmitPasswordAPI: `${apiBase}/pay/qrcodeValueCardOmitPasswordPay.json`,
  wxPayAPI: `${apiBase}/pay/wxPay.json`,
  aliPayAPI: `${apiBase}/pay/aliPay.json`,
  alipayJsAPI: `${apiBase}/pay/alipayJsapi.json`,
  uePayApi: `${apiBase}/pay/uePay.json`,
  bocPayApi: `${apiBase}/pay/bocPay.json`,
  touchngoPayApi: `${apiBase}/pay/touchngoPay.json`,
  mPayApi: `${apiBase}/pay/mPay.json`,

  cancelOrderAPI: `${apiBase}/order/tradeCancel.json`, // 取消订单
  shopListTSAPI: `${apiBase}/shop/list.json`, // 堂食门店列表 全部门店
  shopListTSNearAPI: `${apiBase}/shop/nearByShopList.json`, // 堂食门店列表 附近门店
  nearShopListAPI: `${apiBase}/shop/nearShopList.json`,
  takeawayAllShopListAPI: `${apiBase}/shop/takeawayAllShopList.json`,
  takeawayInfoAPI: `${apiBase}/shop/takeawayInfo.json`, // 外卖信息
  fetchCouponAPI: `${apiBase}/coupon/fetchCoupon.json`, // 点餐页获取优惠券
  sendCouponsAPI: `${apiBase}/coupon/sendCoupon.json`, // 点餐页获取优惠券新接口
  thirdPlatformLogin: `${apiBase}/user/thirdPlatformLogin.json`, // 第三方登录（目前美食岛）
  getPaymentIdByTradeId: `${apiBase}/pay/iParkPay.json`, // 通过orderId获取paymentId

  fakeSocketDataAPI: `${apiBase}/fakeSocketData.json`,

  shareCouponPage: `${apiBase}/coupon/queryMarketSharePage`,
  getShareCouponPage: `${apiBase}/coupon/getShareCouponPage`,
  queryMarketShareAPI: `${apiBase}/coupon/queryMarketShare.json`,
  shareCouponEventAPI: `${apiBase}/coupon/shareEvent.json`,
  shareCreateCoupInstanceAPI: `${apiBase}/coupon/shareCreateCoupInstance.json`,
  dishMenu4DinnerChoosePeopleAPI: `${apiBase}/orderall/dishMenu4DinnerChoosePeople.json`, // 选择人数
  shareRandomPriviledgeAPI: `${apiBase}/marketplan/shareRandomPriviledge.json`,
  shareSuccessAPI: `${apiBase}/orderall/shareSuccess.json`,
  switchUrlBeforeGetServiceStatusAPI: `${apiBase}/shop/getRealUrl.json`,

  getAdGroupAdsJsUrl: `${apiAdsgroup}/ad-js-static/adWebSdk.min.js`,

  rewardIndexAPI: `${apiBase}/reward/index.json`,
  cookIndexAPI: `${apiBase}/cook/cookInfo.json`,
  tableWayAPI: `${apiBase}/shop/tableWay.json`,
  cityListAPI: `${apiBase}/shop/cityList.json`,
  orderFromCurTabeAPI: `${apiBase}/order/orderFromCurTable.json`,
  activeOrderAPI: `${apiBase}/order/activeOrder.json`,
  serviceCardAPI: `${apiBase}/shop/serviceCard.json`,
  brandInfoAPI: `${apiBase}/brand/type.json`,
  becomeNoPasswordAPI: `${apiBase}/pay/becomeNoPassword.json`,
  recommendDishAPI: `${apiBase}/orderall/recommendDishList.json`,
  getRetailAPI: `${apiBase}/takeaway/getWMPageTpl.json`,
  updateBookingLockAPI: `${apiBase}/booking/updateBookingLock.json`,

  getProfessionalCommercialAPI: `${apiBase}/brand/professionalCommercial.json`,
  getCommericalInfoAPI: `${apiBase}/shop/getCommericalInfo.json`,
  getShopMinConsumeConfAPI: `${apiBase}/shop/getShopMinConsumeConf.json`,
  requestOptions,
  syncOrderDinnerSocketUrl,
  sockJsUncheckUrl,

  apiBase,
  apiFintech,
  apiAdsgroup,
  env: process.env.NODE_ENV,

  recommendDishStatisticsAPI: `${apiStatistics}/behavior/recommendDishScanRecord`, // 推荐菜品埋点统计
  getShopBaseConfAPI: `${apiBase}/shop/getShopBaseConf.json`,
  integralMallURL: `${loyaltyHost}/loyalty-mobile/#/`, // 积分商城界面
  integralExchangeDetailUrl: `${loyaltyHost}/loyalty-mobile/#/`, // 积分商城兑换详情页面
  discountCardPurchaseDetail: 'exchangeDetail', // 折扣卡购买成功后跳转页面

  dataRecoveryURL: `${apiBase}/integration/data-recovery`, // 茶百道数据修复
  loginInCCBAppAPI: `${apiBase}/user/ccb/login.json`, // 建行无感登录
  decodeCipherTextForCCB: `${apiBase}/member/ccb/decrypt.json`, // 建行解密

  getMobilesByEuid: `${apiBase}/order/getMobilesByEuid.json`, // 饿了么通过euid获取手机号
  elmLogin: `${apiBase}/user/elmLogin.json`, // 饿了么静默登录

  shopHealthCodeInfoAPI: `${apiBase}/shop/getShopHealthCodeInfo.json`,

  getPayForGiftCoupon: `${apiBase}/coupon/listPayGiftCoupon.json`, // 获取支付有礼数据
  getNowPayForGiftCoupon: `${apiBase}/coupon/payGiftReceiveCoupon.json`, // 领取支付有礼券接口

  // golden-plan
  getAdTypeAPI: `${adHost}/adgold/plan/material`, // 获取物料以及展示形势
  postAdInfo: `${adHost}/adgold/plan/statistic`, // 上报相关信息
  postAdError: `${adHost}/adgold/plan/statistic/error`,

  // 外卖点餐页
  takeawaySelectDish: `${apiBase}/takeaway/selectDish`,

  getOrderComment: `${apiBase}/order/getOrderComment.json`, // 查询订单是否已评价

  mergeSwitchAPI: `${apiBase}/brand/invoice/merge/switch.json`, // 获取是否是嘉旺品牌
  batchInvoiceOrderListAPI: `${apiBase}/order/batchInvoiceOrderList.json`, // 获取嘉旺品牌下订单列表
  batchInvoiceOrderListURL: `${apiBase}/order/batchInvoiceOrderList`,
  batchInvoiceShopListAPI: `${apiBase}/brand/getShopList.json`, // 获取嘉旺品牌下的门店
  invoiceBatchUrl: `${apiBase}/order/invoiceBatchUrl.json`, // 获取批量开发票跳转链接
};



// WEBPACK FOOTER //
// ./src/config.js